<div class="tw:relative">
  <prime-button
    (onClick)="userMenu.toggle($event)"
    [link]="true"
    [text]="true"
    styleClass="tw:px-2 tw:hover:text-surface-0 tw:text-bluegray-600 tw:transition-colors tw:duration-300 tw:ease-in-out"
  >
    <ng-template #contentTemplate>
      <span class="tw:mr-2 tw:font-semibold tw:text-[0.875rem]">{{ userName() }}</span>
      <img
        alt=""
        class="profile-pic tw:block tw:h-auto tw:max-w-full"
        height="36"
        ngSrc="/assets/images/elements/user-profile.png"
        priority
        width="35"
      />
    </ng-template>
  </prime-button>
  <p-popover
    #userMenu
    pinnaklPopoverRight
    styleClass="p-popover-arrow-center tw:py-2 tw:w-56 tw:mt-0"
  >
    <div class="tw:w-full tw:flex tw:flex-col tw:items-center">
      @if (workspaces().length > 1) {
        <div class="tw:px-2 tw:w-full">
          <div
            class="tw:p-2 tw:w-full tw:text-(--p-text-muted-color) tw:tracking-[0.025em] tw:font-semibold tw:text-[11px] tw:leading-4"
          >
            WORKSPACE
          </div>
          @for (workspace of workspaces(); track workspace.id) {
            <div
              (click)="selectWorkspace(workspace.id)"
              [class]="{
                'tw:bg-p-blue-100': workspace.id === selectedWorkspaceId(),
                'tw:hover:bg-p-blue-50': workspace.id !== selectedWorkspaceId(),
                'tw:mt-1': !$first,
              }"
              class="tw:transition-all tw:duration-300 tw:flex tw:w-full tw:p-2 tw:justify-between tw:items-center tw:rounded-(--p-border-radius) tw:cursor-pointer"
            >
              <div class="tw:line-clamp-1">{{ workspace.name }}</div>
              @if (workspace.id === selectedWorkspaceId()) {
                <pinnakl-icon
                  class="tw:p-px tw:flex tw:w-4 tw:h-4 tw:items-center"
                  name="check"
                  data-testid="active-workspace"
                />
              }
            </div>
          }
        </div>
        <div class="tw:my-1 tw:w-full tw:border-b tw:border-bluegray-200"></div>
      }
      <div class="tw:px-2 tw:w-full">
        <prime-button
          (onClick)="userMenu.toggle($event); logout.emit()"
          [text]="true"
          class="tw:w-full"
          label="Logout"
          severity="secondary"
          size="small"
          styleClass="tw:w-full"
        >
        </prime-button>
      </div>
      <div class="tw:mt-1 tw:w-full tw:border-b tw:border-bluegray-200"></div>
      <div class="tw:pt-2 tw:pb-1 tw:px-4 tw:text-(--p-text-muted-color)">Version: {{ version }}</div>
    </div>
  </p-popover>
</div>
